export default {
  matching: {
    training: {
      legend: "Active le module & l'affichage au catalogue",
      domains: {
        delete: {
          title: "Supprimer ce domaine de formation",
        },
      },
    },
    group: {
      title: "Groupe",
      legend: "Ouvre ou ferme les candidatures",
    },
    groups: {
      title: ({ plural }) => plural(["Groupe", "Groupes"]),
      edit: {
        title: "Modifier la fiche groupe",
      },
      view: {
        title: "Consulter la fiche groupe",
      },
      sheet: {
        title: "Fiche groupe",
        title_with_name: "Fiche groupe — {name}",
        candidacy_opening_section: "Ouverture des candidatures",
        objectives_section: "Objectifs & capacité d'accueil",
        save_success: "Fiche groupe enregistrée",
      },
      candidacy_status_upcoming: "À venir",
      candidacy_status_open: "Ouvertes",
      candidacy_status_finalized: "Finalisées",
      candidacy_status_full: "Complet",
      candidacy_status_full_waitlist: "Complet — liste d'attente",
      candidacy_status_closed: "Clôturées",
    },
    prospects: {
      title: ({ plural }) => plural(["Prospect", "Prospects"]),
      view: {
        title: "Voir la fiche",
      },
      send_email: {
        title: "Envoyer un email",
      },
      filters: {
        title: "Filtres rapides",
        active: "Actifs",
        passive: "Passifs",
        unsubscribed: "Désabonnés",
        candidates: "Candidats",
        stages_title: "Filtrer les candidats par étape",
        advanced: {
          title: "Rechercher",
          search_label: "Rechercher par nom ou email",
          results_announcement: ({ plural, named }) =>
            plural(["Aucun résultat", `${named("count")} résultat`, `${named("count")} résultats`]),
        },
      },
    },
    unsubscribeStats: {
      title: "Désinscriptions",
      total: ({ plural, named }) => plural([`${named("count")} désinscription`, `${named("count")} désinscriptions`]),
      by_reason: "Répartition par motif",
      evolution: "Évolution dans le temps",
      reason: "Motif",
      count: "Nombre",
      from: "Période de début (mois)",
      to: "Période de fin (mois)",
    },
    settings: {
      success: "Enregistrement effectué. Les changements sont désormais actifs.",
    },
    config: {
      candidateWorkflow: {
        edit_title: "Modifier l'onglet « {name} »",
        edit_success: "Onglet enregistré",
        blocks: {
          edit_title: "Modifier le bloc « {name} »",
          edit_success: "Bloc enregistré",
        },
        fields: {
          edit_title: "Modifier le champ « {name} »",
          edit_success: "Champ enregistré",
          conditional: "Affiché seulement si « {target} » est renseigné",
        },
        steps: {
          intro: "Les étapes",
          edit_title: "Modifier l'étape « {name} »",
          edit_success: "Étape enregistrée",
        },
      },
    },
    catalog: {
      title: ({ plural }) => plural(["Catalogue", "Catalogues"]),
      edit: {
        title: "Modifier la fiche catalogue",
      },
      view: {
        title: "Consulter la fiche catalogue",
      },
      sheet: {
        title: "Fiche catalogue",
        title_with_name: "Fiche catalogue — {name}",
        subtitle: "Éléments visibles sur le catalogue et la landing page",
        mode_edit: "Mode modification",
        mode_view: "Lecture seule — droit non accordé",
        presentation_image: "Image de présentation",
        presentation_text: "Texte de présentation",
        commercial_brochure: "Plaquette commerciale",
        website_url: "URL du site internet",
        no_file: "Aucun fichier",
        qr_code_alt: "QR code de la fiche catalogue",
        qr_url_label: "Lien encodé par le QR code",
        save_success: "Fiche catalogue enregistrée",
        download_unavailable: "Aucune plaquette disponible au téléchargement.",
        actions: {
          replace: "Remplacer",
          remove: "Supprimer",
          download: "Télécharger",
          copy: "Copier l'image",
          copy_success: "QR code copié dans le presse-papier !",
          copy_error: "Impossible de copier le QR code.",
          copy_unsupported: "La copie d'image n'est pas supportée par votre navigateur.",
          copy_url: "Copier le lien",
          copy_url_success: "Lien copié dans le presse-papier !",
          copy_url_error: "Impossible de copier le lien.",
          uploading: "Envoi du fichier en cours…",
          upload_error: "Une erreur est survenue lors de l'envoi du fichier.",
        },
      },
    },
    landing_page: {
      add: {
        title: "Ajouter une origine",
        success: "Origine ajoutée avec succès !",
      },
      edit: {
        title: "Modifier cette origine",
        success: "Origine modifiée avec succès !",
      },
      delete: {
        title: "Supprimer cette origine",
        confirmation: "Êtes-vous sûr de vouloir supprimer cette origine de landing page ?",
        success: "Origine de landing page supprimée avec succès !",
      },
      qr_code: {
        see: "Voir le QR code",
        title: "QR code de la landing page",
        alt: "QR code de la landing page",
        download: "Télécharger",
        copy: "Copier l'image",
        copy_success: "QR code copié dans le presse-papier !",
        copy_error: "Impossible de copier le QR code.",
        copy_unsupported: "La copie d'image n'est pas supportée par votre navigateur.",
      },
      url: {
        copy: {
          title: "Copier le lien",
          success: "Lien copié avec succès !",
        },
      },
      filters: {
        level: {
          label: "Niveau d'étude visé",
          unknown: "Je ne sais pas",
          load_error: "Impossible de charger les niveaux, merci de réessayer.",
          retry: "Réessayer",
        },
        domain: {
          label: "Domaine de formation",
          hint_multiple: "(plusieurs choix possibles)",
          search_placeholder: "Rechercher un domaine (ex. informatique, commerce…)",
          empty_search: "Aucun domaine ne correspond à « {search} ».",
          select_level_first: "Choisissez un niveau d'étude pour voir les domaines disponibles.",
          show_all: "Afficher les {count} domaines",
          collapse: "Réduire les domaines",
          load_error: "Impossible de charger les domaines, merci de réessayer.",
          retry: "Réessayer",
          remove: "Retirer {name}",
          formation_count: ({ plural, named }) =>
            plural([`${named("count")} formation`, `${named("count")} formations`]),
        },
        training: {
          label: "Formations disponibles",
          search_placeholder: "Rechercher une formation par mots-clés…",
          selected_count: ({ plural, named }) =>
            plural([
              `${named("count")}/${named("max")} formation sélectionnée`,
              `${named("count")}/${named("max")} formations sélectionnées`,
            ]),
          // Sans plafond (attr["data-max-count"] absent) : pas de "/{max}" à afficher.
          selected_count_no_max: ({ plural, named }) =>
            plural([`${named("count")} formation sélectionnée`, `${named("count")} formations sélectionnées`]),
          total_count: ({ plural, named }) => plural([`${named("total")} résultat`, `${named("total")} résultats`]),
          load_more: ({ plural, named }) =>
            plural([
              `Voir ${named("count")} formation de plus (${named("remaining")} restantes)`,
              `Voir ${named("count")} formations de plus (${named("remaining")} restantes)`,
            ]),
          adapted_to_level: "Adapté à votre niveau",
          empty: "Aucune formation ne correspond à ces critères pour le moment.",
          more_info: "Plus d'infos",
          close: "Fermer",
          select: "Sélectionner cette formation",
          selected: "Formation sélectionnée",
          max_selection_reached: "Vous ne pouvez sélectionner que {max} formations maximum.",
          load_error: "Impossible de charger les formations, merci de réessayer.",
          retry: "Réessayer",
        },
      },
    },
    candidateStudies: {
      title: "Mes études",
      intro: "Renseignez vos diplômes et certifications pour compléter votre candidature.",
      add: "Ajouter",
      add_degree_title: "Ajouter un diplôme",
      edit_degree_title: "Modifier ce diplôme",
      add_certification_title: "Ajouter une certification",
      edit_certification_title: "Modifier cette certification",
      save_success: "Entrée enregistrée",
      empty: "Aucune entrée pour le moment",
      minimum_not_reached: "Ajoutez au moins une entrée pour compléter ce bloc",
      max_reached_tooltip: "Nombre maximum d'entrées atteint",
      delete_confirm_title: "Supprimer cette entrée ?",
      delete_success: "Entrée supprimée",
      move_up: "Monter",
      move_down: "Descendre",
      moved: "{name} : entrée numéro {position} sur {total}.",
      reorder_error: "L'ordre de vos entrées n'a pas pu être enregistré, l'ordre précédent est conservé.",
      entry: {
        edit: "Modifier",
        delete: "Supprimer",
        degree_type: "Type de diplôme",
        institution: "École",
        department: "Département",
        country: "Pays",
        year: "Année",
        organization: "Organisme",
      },
    },
    candidateInformation: {
      read_only_notice: "Cet onglet n'est plus modifiable à cette étape de votre dossier.",
      steps_title: "Mon dossier",
      title: "Mes informations",
      tab_empty: "Cet onglet sera bientôt disponible.",
      load_error: "Impossible de charger votre dossier, merci de réessayer.",
      retry: "Réessayer",
    },
    applications: {
      hint_reorder:
        "Classez vos vœux par ordre de préférence : faites glisser une carte par sa poignée ou utilisez les boutons Monter et Descendre.",
      empty: "Vous n'avez pas encore de vœu de candidature.",
      rank: ({ named }) => (named("rank") === 1 ? "1er vœu" : `${named("rank")}e vœu`),
      move_up: "Monter le vœu {name}",
      move_down: "Descendre le vœu {name}",
      moved: "{name} : vœu numéro {position} sur {total}.",
      reorder_error: "L'ordre de vos vœux n'a pas pu être enregistré, l'ordre précédent est conservé.",
      closed_title: "Vœux clos",
      view: "Voir",
      edit: "Modifier",
      tab_count: "{count} vœu actif | {count} vœux actifs",
      modal: {
        title: "Mon vœu",
        training: "Formation",
        group: "Groupe",
        status: "Statut",
        year: "Année",
        letter_label: "Lettre de motivation",
        letter_hint: "{max} caractères maximum.",
        letter_counter: "{count} / {max} caractères",
        letter_locked: "Votre lettre de motivation n'est plus modifiable à cette étape.",
        save: "Enregistrer",
        close: "Fermer",
        saved: "Lettre de motivation enregistrée",
        withdraw: "Retirer ce vœu",
        withdraw_confirm: "Voulez-vous vraiment retirer ce vœu ?",
        withdraw_confirm_yes: "Oui, retirer ce vœu",
        withdraw_cancel: "Annuler",
        withdrawn: "Vœu retiré",
      },
    },
  },
};
